export default __webpack_public_path__ + "static/media/login_rouding_background_1.81f7c3f1.png";